import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Dots = (props) => (
  <Icon viewBox="0 0 512 512" {...props}>
    <g>
      <path d="M448.046 191.984c-35.337 0-64.016 28.647-64.016 64.016s28.679 64.015 64.015 64.015c35.337 0 64.015-28.647 64.015-64.016s-28.678-64.016-64.015-64.016zm-192.046 0c-35.337 0-64.016 28.647-64.016 64.016s28.679 64.015 64.016 64.015 64.015-28.647 64.015-64.016-28.679-64.016-64.016-64.016zm-192.047 0C28.616 191.984-.063 220.631-.063 256s28.679 64.015 64.016 64.015 64.016-28.647 64.016-64.016-28.679-64.016-64.016-64.016z"
      />
    </g>
  </Icon>
);
/*eslint-enable */

export default Dots;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Dots.js